import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const BoardDragContext = createContext(null);

export const BoardDragProvider = ({ children }) => {
  const [dragData, setDragData] = useState(null);

  const startDrag = useCallback(payload => {
    setDragData(payload);
  }, []);

  const endDrag = useCallback(() => {
    setDragData(null);
  }, []);

  const value = useMemo(
    () => ({
      dragData,
      isDragging: Boolean(dragData),
      isEnabled: true,
      startDrag,
      endDrag,
    }),
    [dragData, startDrag, endDrag]
  );

  return (
    <BoardDragContext.Provider value={value}>{children}</BoardDragContext.Provider>
  );
};

export const useBoardDrag = () => {
  const ctx = useContext(BoardDragContext);
  if (!ctx) {
    return {
      dragData: null,
      isDragging: false,
      isEnabled: false,
      startDrag: () => {},
      endDrag: () => {},
    };
  }
  return ctx;
};
